import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import constraintInputNames from '../optimizer-utils/input-names';

type RelaxOrderProps = {
  params: types.optimizer.ConstraintDraft;
  setParams: (_params: types.optimizer.ConstraintDraft & { constraint_type?: any }) => void;
  disabled?: boolean;
};

const RelaxOrder = ({ params, setParams, disabled }: RelaxOrderProps) => {
  return (
    <mui.core.Grid size={{ xs: 12, md: 6 }}>
      <mui.core.TextField
        select
        label={constraintInputNames.relax_order}
        variant="outlined"
        disabled={disabled}
        value={params.relax_order || 'NEVER'}
        onChange={(e: any) =>
          setParams({
            ...params,
            relax_order: e.target.value as types.optimizer.ConstraintDraft['relax_order'],
          })
        }
        fullWidth
        size="small"
      >
        <mui.core.MenuItem value={'FIRST'}>First</mui.core.MenuItem>
        <mui.core.MenuItem value={'SECOND'}>Second</mui.core.MenuItem>
        <mui.core.MenuItem value={'LAST'}>Last</mui.core.MenuItem>
        <mui.core.MenuItem value={'NEVER'}>Never</mui.core.MenuItem>
      </mui.core.TextField>
    </mui.core.Grid>
  );
};

export default RelaxOrder;
